<mat-form-field [appearance]="appearance" [floatLabel]="label ? 'auto' : 'always'" class="w-full">
  <mat-label>{{ label }}</mat-label>
  <fb-anex
    *ngIf="prefix"
    matPrefix
    [config]="prefix"
    [control]="control"
    [templates]="templates"
    position="start"
  ></fb-anex>
  <input
    [required]="required"
    matInput
    fbDisableAutocomplete
    [placeholder]="placeholder"
    [formControl]="autocompleteControl"
    [matAutocomplete]="auto"
    [fbDisableControl]="disable"
    [readonly]="readonly"
    #trigger="matAutocompleteTrigger"
    (blur)="onInputBlur()"
    (focusout)="onTouched()"
  />

  <ng-container *ngIf="(loading.active$ | async) === false; else showLoader">
    <ng-container *ngIf="suffix; else showButtons">
      <fb-anex
        matSuffix
        [config]="suffix"
        [control]="ngControl.control"
        [templates]="templates"
        position="end"
      ></fb-anex>
    </ng-container>
    <ng-template #showButtons>
      <button
        *ngIf="allowEmpty && value !== undefined && value !== null && !disable"
        tabindex="-1"
        type="button"
        mat-icon-button
        matSuffix
        (click)="onClear(); onTouched(); trigger.closePanel(); $event.stopPropagation(); $event.preventDefault()"
        [disabled]="disable || readonly"
      >
        <mat-icon [inline]="true" class="icon-button">clear</mat-icon>
      </button>
      <button
        *ngIf="value === undefined || value === null || (!allowEmpty && !disable)"
        tabindex="-1"
        type="button"
        mat-icon-button
        matSuffix
        (click)="
          trigger.panelOpen ? trigger.closePanel() : trigger.openPanel();
          $event.stopPropagation();
          $event.preventDefault()
        "
        [disabled]="disable || readonly"
      >
        <ng-container *ngIf="!trigger.panelOpen; else upIcon">
          <mat-icon [inline]="true" class="icon-button">keyboard_arrow_down</mat-icon>
        </ng-container>
        <ng-template #upIcon>
          <mat-icon [inline]="true" class="icon-button">keyboard_arrow_up</mat-icon>
        </ng-template>
      </button>
    </ng-template>
  </ng-container>
  <ng-template #showLoader>
    <fb-loader class="position-relative loader" [size]="16" [message]="undefined" matSuffix></fb-loader>
  </ng-template>

  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayValue">
    <ng-container *ngFor="let group of filteredValues$ | async">
      <ng-container *ngIf="group; else showNoData">
        <div class="disabled-option" *ngIf="group.groupLabel" [title]="group.groupLabel">
          <div class="d-flex align-items-center t-body-text-medium w-full group-name">
            {{ group.groupLabel }}
          </div>
        </div>

        <mat-option *ngFor="let option of group.options" [value]="option" [title]="option.label">
          <div class="d-block truncate" [class.pl-8]="group.groupLabel">
            {{ option.label }}
          </div>
        </mat-option>
      </ng-container>
      <ng-template #showNoData>
        <mat-option [disabled]="true">
          <div class="text-center not-found">Not found</div>
        </mat-option>
      </ng-template>
    </ng-container>
  </mat-autocomplete>
</mat-form-field>
